/*import { AfterContentInit, AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import * as _ from 'lodash';
import { TreeNode, TreeOptions, TreeData } from '../tree.interface';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { TreeComponent } from '../tree.component';
import { fadeInOutWithBlur } from '../../global-app-animations';

@Component({
    selector: 'app-node',
    templateUrl: './node.component.html',
    styleUrls: ['./node.component.scss'],
    providers: [TreeComponent],
    animations: [
        fadeInOutWithBlur
    ],
    standalone: false
})

export class NodeComponent implements OnInit {
  @Input() data: TreeNode | undefined;
  @Input() expand?: boolean;
  @Input() mobile?: boolean;
  @Input() parentIcon?: string;
  @Input() expanded: boolean = false; //expanded is global
  //outputs 
  @Output() onNodeClick: EventEmitter<any> = new EventEmitter<any>();

  //field: Object;

  parsedOptions: TreeOptions | undefined;
  parsedData: TreeData | undefined;

  constructor(private router: Router, private tree: TreeComponent) {
    //this.field = { dataSource: this.data, id: 'id', text: 'name', child: 'children' };
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if(event.url != router.url){
          this.nodeOperation(event.url);
        }

        setTimeout(() => {
          this.nodeOperation(router.url);
        }, 100);
      }

    });
  }

  ngOnInit(): void {
    this.nodeOperation(this.router.url);
  }


  expandNode(name: string) {

    this.data!.expand = !this.data!.expand
    this.expand = this.data?.expand;
    if (this.data!.iconClass == 'icon-chevron-down') {
      this.data!.iconClass = 'icon-chevron-up'
    } else {
      this.data!.iconClass = 'icon-chevron-down';
    }
  }

  onNodeSelect(event: any, route: TreeNode | undefined) {
    //console.log(event.nodeData);
    //let data:any = this.tree!.getTreeData(event.node.id);    
    //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
    //console.log(seriusData[0]['route']);
    //this.router.navigate([event]);
    //this.router.navigateByUrl(route.startsWith('/') ? route : `/${route}`);
    // Prevent default Firefox behavior and stop propagation
    event?.preventDefault();
    event?.stopImmediatePropagation();
    const clonedRoute = route ? { ...route } : undefined;
    setTimeout(() => {      
      console.error("\n \n THIS IS THE ROUTE TO NAVIGATE TO \n \n");
      console.error(route);
      console.error(clonedRoute);

      if(clonedRoute != undefined) {
        if(clonedRoute.route != undefined) {
          this.router.navigateByUrl(clonedRoute.route.startsWith('/') ? clonedRoute.route : `/${clonedRoute.route}`);
        }
      }else{
        if(route?.route != undefined) {
          this.router.navigateByUrl(route.route.startsWith('/') ? route.route : `/${route.route}`);
        }
      }

      this.onNodeClick.emit(route);
    }, 0);
  }

  keyDwn(event: any, route: string) {
    if(event.key == 'Enter') {
      this.router.navigate([route]);
    }
  }


  expandOnFocus(event: any, route: string) {
    if(event.key == 'Enter') {
      this.expandNode(route);
    }
  }

  newWindow(event: any) {
    //console.log(event.nodeData);
    //let data:any = this.tree!.getTreeData(event.node.id);    
    //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
    //console.log(seriusData[0]['route']);
    // this.router.navigate([event]); 
    window.open(event, '_blank')
    //this.onNodeClick.emit(event);
  }


    nodeOperation(url: string) {
      // Normalize the base route for this data node.
      let route = this.data!.route.startsWith('/') ? this.data!.route : '/' + this.data!.route;
      
      // Reset the parent's css class
      this.data!.cssClass = '';
      this.data!.expand = false;
    
      // Create a regex that checks that the URL path starts with the given route
      // followed by a '/' or the end of string.
      let regex = new RegExp(`^${route}(\\/|$)`);
    
      if (regex.test(url)) {
        this.data!.cssClass = 'node-selected';
        this.data!.expand = true;
      }
    
      // Recursively check all children.
      this.data!.children.forEach(child => {
        this.nodeRepeat(child, url);
      });
    
      // Update the icon based on whether the node is expanded.
      this.data!.iconClass = this.data!.expand ? 'icon-chevron-up' : 'icon-chevron-down';
    }
    

    nodeRepeat(nodeCh: TreeNode, url: string) {
      // Ensure the node's route has a leading slash.
      let routeCh = nodeCh.route.startsWith('/') ? nodeCh.route : '/' + nodeCh.route;
      
      // Reset node state.
      nodeCh.expand = false;
      nodeCh.cssClass = '';
    
      // Build a regular expression that matches the node route at the beginning of the path.
      // The regex ensures that the route is followed by a '/' or it ends there.
      let regex = new RegExp(`^${routeCh}(\\/|$)`);
      
      // If the URL (after stripping any base like host+port, if necessary) matches the route...
      if (regex.test(url)) {
        nodeCh.cssClass = 'node-selected';
        // Optionally expand the parent if a child is active.
        this.data!.expand = true;
      }
    
      // If there are child nodes, run this function recursively.
      if (nodeCh.children && nodeCh.children.length > 0) {
        nodeCh.children.forEach(child => {
          this.nodeRepeat(child, url);
        });
      }
    }

    navigateToRoute(event: any, data: TreeNode | undefined, newWindow?: boolean) {
      console.warn(data?.route);
      console.warn(data?.name);
      if(data?.route != undefined) {

        if(newWindow == true) {
          window.open(data.route, '_blank')
          return;
        }

        this.router.navigateByUrl(data.route.startsWith('/') ? data.route : `/${data.route}`);
      }
    }

}*/


import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import * as _ from 'lodash';
import { TreeNode, TreeOptions, TreeData } from '../tree.interface';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { TreeComponent } from '../tree.component';
import { fadeInOutWithBlur } from '../../global-app-animations';

@Component({
    selector: 'app-node',
    templateUrl: './node.component.html',
    styleUrls: ['./node.component.scss'],
    providers: [TreeComponent],
    animations: [
      fadeInOutWithBlur,
        trigger('onOff', [
            transition(':enter', [
                style({ opacity: 0, height: '0', filter: 'blur(40px)' }),
                animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 1, height: '*', filter: 'blur(0)' }))
            ]),
            transition(':leave', [
                style({ opacity: 1, height: '*', filter: 'blur(0)' }),
                animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 0, height: '0', filter: 'blur(40px)' }))
            ])
        ]),
        trigger('onOff2', [
            transition(':enter', [
                style({ opacity: 0, width: '0', filter: 'blur(40px)' }),
                animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 1, width: '*', filter: 'blur(0)' }))
            ]),
            transition(':leave', [
                style({ opacity: 1, width: '*', filter: 'blur(0)' }),
                animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 0, width: '0', filter: 'blur(40px)' }))
            ])
        ]),
        trigger('showNewPageButton', [
            state('false', style({ opacity: 1, })),
            state('true', style({ opacity: 0 })),
            transition('false => true', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
            transition('true => false', animate('300ms cubic-bezier(.51,.38,.57,.85)'))
        ]),
    ],
    standalone: false
})

export class NodeComponent implements OnInit {
  @Input() data: TreeNode | undefined;
  @Input() expand?: boolean;
  @Input() mobile?: boolean;
  @Input() parentIcon?: string;
  @Input() expanded: boolean = false; //expanded is global
  //outputs 
  @Output() onNodeClick: EventEmitter<any> = new EventEmitter<any>();

  //field: Object;

  parsedOptions: TreeOptions | undefined;
  parsedData: TreeData | undefined;

  constructor(private router: Router, private tree: TreeComponent) {
    //this.field = { dataSource: this.data, id: 'id', text: 'name', child: 'children' };
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.nodeOperation(event.url);
      }

    });
  }

  ngOnInit(): void {
    this.nodeOperation(this.router.url);
  }

  expandNode(name: string) {

    this.data!.expand = !this.data!.expand
    this.expand = this.data?.expand;
    if (this.data!.iconClass == 'icon-chevron-down') {
      this.data!.iconClass = 'icon-chevron-up'
    } else {
      this.data!.iconClass = 'icon-chevron-down';
    }
  }

  onNodeSelect(event: any) {
    //console.log(event.nodeData);
    //let data:any = this.tree!.getTreeData(event.node.id);    
    //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
    //console.log(seriusData[0]['route']);
    this.router.navigate([event]);
    this.onNodeClick.emit(event);
  }

  keyDwn(event: any, route: string) {
    if(event.key == 'Enter') {
      this.router.navigate([route]);
    }
  }


  expandOnFocus(event: any, route: string) {
    if(event.key == 'Enter') {
      this.expandNode(route);
    }
  }

  newWindow(event: any) {
    //console.log(event.nodeData);
    //let data:any = this.tree!.getTreeData(event.node.id);    
    //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
    //console.log(seriusData[0]['route']);
    // this.router.navigate([event]); 
    window.open(event, '_blank')
    //this.onNodeClick.emit(event);
  }

/*   nodeOperation(url: string) {

    let route = '/' + this.data!.route;

    this.data!.cssClass = ''


    if (url.includes(route)) {
      this.data!.expand = true;
      this.data!.cssClass = 'node-selected'
    }

    this.data!.children.forEach(nodeCh => {
      // let routeCh = '/'+nodeCh.route;
      // nodeCh.expand = false;
      // nodeCh.cssClass = ''
      // let routeSplit = routeCh.split('/');
      // let lastOne = '';
      // routeSplit.forEach(rs=>{
      //   lastOne = rs;
      // })
      //   if(url.includes(routeCh) || url.includes(lastOne)){

      //   nodeCh.cssClass = 'node-selected'
      //   node.expand = true;
      // }
      this.nodeRepeat(nodeCh, url)

    })

    if (this.data!.expand) {
      this.data!.iconClass = 'icon-chevron-up'
    } else {
      this.data!.iconClass = 'icon-chevron-down'
    }

  } */


  /* nodeRepeat(nodeCh: TreeNode, url: string) {
    console.log(nodeCh.route);
    let routeCh = '/' + nodeCh.route;
    nodeCh.expand = false;
    nodeCh.cssClass = ''
    let routeSplit = routeCh.split('/');
    let lastOne = '';
    routeSplit.forEach(rs => {
      lastOne = rs;
    })
    if (url.includes(routeCh) || url.includes(lastOne)) {

      nodeCh.cssClass = 'node-selected'

      this.data!.expand = true;


    }

    if (nodeCh.children.length > 0) {
      nodeCh.children.forEach(nodeChCh => {
        this.nodeRepeat(nodeChCh, url)
      })
    }


  } */

    nodeOperation(url: string) {
      // Normalize the base route for this data node.
      let route = this.data!.route.startsWith('/') ? this.data!.route : '/' + this.data!.route;
      
      // Reset the parent's css class
      this.data!.cssClass = '';
      this.data!.expand = false;
    
      // Create a regex that checks that the URL path starts with the given route
      // followed by a '/' or the end of string.
      let regex = new RegExp(`^${route}(\\/|$)`);
    
      if (regex.test(url)) {
        this.data!.cssClass = 'node-selected';
        this.data!.expand = true;
      }
    
      // Recursively check all children.
      this.data!.children.forEach(child => {
        this.nodeRepeat(child, url);
      });
    
      // Update the icon based on whether the node is expanded.
      this.data!.iconClass = this.data!.expand ? 'icon-chevron-up' : 'icon-chevron-down';
    }
    

    nodeRepeat(nodeCh: TreeNode, url: string) {
      // Ensure the node's route has a leading slash.
      let routeCh = nodeCh.route.startsWith('/') ? nodeCh.route : '/' + nodeCh.route;
      
      // Reset node state.
      nodeCh.expand = false;
      nodeCh.cssClass = '';
    
      // Build a regular expression that matches the node route at the beginning of the path.
      // The regex ensures that the route is followed by a '/' or it ends there.
      let regex = new RegExp(`^${routeCh}(\\/|$)`);
      
      // If the URL (after stripping any base like host+port, if necessary) matches the route...
      if (regex.test(url)) {
        nodeCh.cssClass = 'node-selected';
        // Optionally expand the parent if a child is active.
        this.data!.expand = true;
      }
    
      // If there are child nodes, run this function recursively.
      if (nodeCh.children && nodeCh.children.length > 0) {
        nodeCh.children.forEach(child => {
          this.nodeRepeat(child, url);
        });
      }
    }
    
    

}

